module.exports = __webpack_public_path__ + "static/media/radio.45489db5.svg";